import React from 'react';
import PropTypes from 'prop-types';
import { Condition } from '@upstart/harmony/lib/legos/constants';

function ConditionCheckbox({ selected, onChange, dealer }) {
  const toggleCondition = condition => {
    let newConditions = [...selected];
    if (newConditions.includes(condition)) {
      newConditions = newConditions.filter(c => c !== condition);
    } else {
      newConditions.push(condition);
    }
    onChange(newConditions);
  };

  const renderConditionCheckbox = condition => (
    <div>
      <input
        type="checkbox"
        onChange={() => toggleCondition(condition)}
        checked={selected.includes(condition)}
      />{' '}
      {condition}
    </div>
  );

  return (
    <>
      <label>Condition</label>
      {renderConditionCheckbox(Condition.NEW)}
      {renderConditionCheckbox(Condition.USED)}
      {!!dealer?.featureConfig?.useCPO?.enabled &&
        renderConditionCheckbox(Condition.CPO)}
    </>
  );
}

ConditionCheckbox.propTypes = {
  selected: PropTypes.array,
  onChange: PropTypes.func,
  dealer: PropTypes.object,
};

export default ConditionCheckbox;
